/**
 * Utility functions for search input detection and validation
 */

/**
 * Checks if the input string is a valid MAC address
 * Supports formats: AA:BB:CC:DD:EE:FF, AA-BB-CC-DD-EE-FF, AABBCCDDEEFF
 */
export function isMacAddress(input: string): boolean {
  // MAC address patterns: AA:BB:CC:DD:EE:FF, AA-BB-CC-DD-EE-FF, AABBCCDDEEFF
  const macPatterns = [
    /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/, // AA:BB:CC:DD:EE:FF or AA-BB-CC-DD-EE-FF
    /^([0-9A-Fa-f]{12})$/, // AABBCCDDEEFF
  ]

  return macPatterns.some((pattern) => pattern.test(input.trim()))
}

/**
 * Checks if the input string is a valid MongoDB ObjectId
 * ObjectId format: 24 character hex string
 */
export function isObjectId(input: string): boolean {
  // MongoDB ObjectId: 24 character hex string
  const objectIdPattern = /^[0-9a-fA-F]{24}$/
  return objectIdPattern.test(input.trim())
}

/**
 * Checks if the input string looks like an email address
 */
export function isEmail(input: string): boolean {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailPattern.test(input.trim())
}

/**
 * Checks if the input appears to be a searchable identifier
 * (MAC address or ObjectId)
 */
export function isSearchableId(input: string): boolean {
  return isMacAddress(input) || isObjectId(input)
}

/**
 * Checks if the current active element is an input field where paste should be ignored
 */
export function isActiveElementInput(): boolean {
  const activeElement = document.activeElement
  if (!activeElement) {
    return false
  }

  const tagName = activeElement.tagName.toLowerCase()
  const isContentEditable =
    activeElement.getAttribute("contenteditable") === "true"
  const isInput = tagName === "input" || tagName === "textarea"

  return isInput || isContentEditable
}
